import { useEffect, useContext } from 'react'
import RootStore from '../stores/RootStore'

export function useGlobalShortcuts() {
  const store = useContext(RootStore)

  useEffect(() => {
    // Only add event listeners in browser environment
    if (typeof window === 'undefined') return

    const handleKeyDown = (event: KeyboardEvent) => {
      // Check if it's just Alt/Option + S without other modifiers
      if (
        event.altKey &&
        !event.ctrlKey &&
        !event.metaKey &&
        !event.shiftKey &&
        event.code.toLowerCase().includes('s')
      ) {
        event.preventDefault()
        event.stopPropagation()
        store.searchStore.showSearch()
      }
    }

    window.addEventListener('keydown', handleKeyDown, true)
    return () => window.removeEventListener('keydown', handleKeyDown, true)
  }, [store])
}